import React from "react";
import styled from "styled-components";
import Icon from "../icons/Icon";
import { apolloFontFamilyBodySmall, apolloFontSizeBody, apolloFontSizeBodySmall, apolloFontWeightBodySmall, apolloLineHeightBody, apolloLineHeightBodySmall, apolloSpaceInline1X, apolloSpaceInline3X, apolloSpaceStack1X, } from "@nexthink/apollo-tokens";
import Error from "@nexthink/apollo-tokens/lib/images/react/Error";
const BORDER_BOX = "border-box";
const checkboxSize = 16;
const errorIconSize = 16;
const borderWidth = 1;
export const checkboxOuterSize = checkboxSize + borderWidth * 2;
const StyledWrapperRef = styled.div.withConfig({ displayName: "StyledWrapperRef_APC-7281-productShell", componentId: "sc-1xrc1uo" })({});
export const StyledWrapper = styled(StyledWrapperRef).withConfig({ displayName: "StyledWrapper_APC-7281-productShell", componentId: "sc-oeqo9k" })(({ display }) => (Object.assign({}, (display === "inline"
    ? {
        display: "inline-flex",
        verticalAlign: "middle",
        marginRight: apolloSpaceInline3X,
        marginTop: 0,
    }
    : {
        display: "flex",
        [`&${StyledWrapperRef} ~ &${StyledWrapperRef}`]: {
            marginTop: apolloSpaceStack1X,
        },
    }))));
export const getPseudoBeforeBackgroundShadowStyle = (theme, checked, disabled) => {
    if (checked && disabled) {
        return {
            background: theme.colors.apolloColorBackgroundFormElementCheckedDisabled,
            boxShadow: theme.colors.apolloBoxShadowFormElementCheckedDisabled,
        };
    }
    if (checked) {
        return {
            background: theme.colors.apolloColorBackgroundFormElementCheckedDefault,
            boxShadow: theme.colors.apolloBoxShadowFormElementChecked,
        };
    }
    if (disabled) {
        return {
            background: theme.colors.apolloColorBackgroundFormElementDisabled,
            boxShadow: theme.colors.apolloBoxShadowFormElementDisabled,
        };
    }
    return {
        background: theme.colors.apolloColorBackgroundFormElementDefault,
        boxShadow: theme.colors.apolloBoxShadowFormElement,
    };
};
export const getPseudoBeforeBorderColor = (theme, disabled, error) => {
    if (disabled) {
        return theme.colors.apolloColorStrokeFormElementDisabled;
    }
    else if (error) {
        return theme.colors.apolloColorStrokeError;
    }
    return theme.colors.apolloColorStrokeFormElementDefault;
};
export const StyledLabel = styled.label.withConfig({ displayName: "StyledLabel_APC-7281-productShell", componentId: "sc-1ty32z" })(({ theme, checked, disabled, error, focused }) => ({
    border: focused ? `${borderWidth}px solid ${theme.colors.apolloColorStrokeFocus}` : "none",
    boxShadow: focused ? theme.colors.apolloBoxShadowFormElementFocusHighlight : "none",
    boxSizing: BORDER_BOX,
    color: disabled ? theme.colors.apolloColorTextDisabled : theme.colors.apolloColorTextPrimary,
    cursor: disabled ? "auto" : "pointer",
    display: "inline-flex",
    font: `${apolloFontWeightBodySmall} ${apolloFontSizeBodySmall}/${apolloLineHeightBodySmall} ${apolloFontFamilyBodySmall}`,
    height: "100%",
    overflow: "hidden",
    padding: focused ? 0 : `${borderWidth}px`,
    paddingLeft: focused ? `${checkboxSize}px` : `${checkboxSize + borderWidth}px`,
    position: "relative",
    minWidth: `${checkboxOuterSize}px`,
    minHeight: `${checkboxOuterSize}px`,
    lineHeight: apolloLineHeightBody,
    fontSize: apolloFontSizeBody,
    "& input+span": {
        marginLeft: apolloSpaceInline1X,
    },
    "&::before": Object.assign(Object.assign({}, getPseudoBeforeBackgroundShadowStyle(theme, checked, disabled)), { border: `${borderWidth}px solid ${getPseudoBeforeBorderColor(theme, disabled, error)}`, borderRadius: "2px", boxSizing: BORDER_BOX, content: "''", display: "inline-block", height: checkboxSize, position: "absolute", left: focused ? 0 : borderWidth, top: focused ? 0 : borderWidth, width: checkboxSize }),
}));
export const StyledInput = styled.input.withConfig({ displayName: "StyledInput_APC-7281-productShell", componentId: "sc-q8ra7c" })(({ disabled }) => ({
    opacity: 0,
    left: "-1px",
    top: "-1px",
    position: "absolute",
    cursor: disabled ? "auto" : "pointer",
}));
export const StyledIcon = styled(({ className, indeterminate }) => (React.createElement(Icon, { name: indeterminate ? "dash" : "check", className: className }))).withConfig({ displayName: "StyledIcon_APC-7281-productShell", componentId: "sc-1hcyd1w" })(({ theme, disabled, checked, indeterminate, focused }) => ({
    position: "absolute",
    left: checkboxSize / 2 + (focused ? 0 : 1),
    top: checkboxSize / 2 + (focused ? 0 : 1),
    transform: "translate(-50%, -50%)",
    boxSizing: BORDER_BOX,
    fontSize: "1rem",
    color: disabled
        ? theme.colors.apolloColorFillFormElementSelectedDisabled
        : theme.colors.apolloColorFillFormElementSelected,
    display: checked || indeterminate ? "block" : "none",
}));
export const StyledErrorIcon = styled(Error).withConfig({ displayName: "StyledErrorIcon_APC-7281-productShell", componentId: "sc-drnukk" })(({ theme }) => ({
    color: theme.colors.apolloColorStrokeError,
    height: errorIconSize,
    width: errorIconSize,
}));
//# sourceMappingURL=Checkbox.style.js.map